import React, { Component } from 'react'
import { connect } from 'react-redux'
import { formatUrl } from '../../util/formatUtils'
import { push } from 'connected-react-router'

import {
  Location,
  LocationBuilding,
  LocationContainer,
} from '../common/Location'
import { SpinnerCard } from '../common/Layout'
import { OrderCart } from '../cart/Cart'
import SidebarDeliveryLocation from '../common/SidebarDeliveryLocation'
import {
  removeItemFromOrderCartStart,
  cancelEditingOrder,
  loadEditOrder,
} from '../../redux/modules/cart'
import ModalPopup from '../common/ModalPopup'
import PersonalizeOrder from '../personalize-order/PersonalizeOrder'
import {
  selectCurrentLocationWithAddress,
  selectMenuItemForEdit,
} from '../../redux/modules/selectors'
import { currentUserStart } from '../../redux/modules/user'
import { checkoutRoute } from '../../routes/routes'
import stickyfilljs from 'stickyfilljs'
import { SubscriptionPromoButtonRotatingTitle } from '../home/SubscriptionPromotional'

export class OrderSidebar extends Component {
  constructor(props) {
    super(props)

    this.state = {
      top: 0,
      scrollListen: true,
    }

    this.handleScroll = this.handleScroll.bind(this)
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll)
  }

  throttleHandleScroll = () => {
    setTimeout(() => {
      this.setState({ scrollListen: true }, () => stickyfilljs.refreshAll())
    }, 100)
  }

  handleScroll() {
    if (this.state.scrollListen) {
      this.setState({ scrollListen: false }, () => {
        const sidebar = document.querySelector('.sticky.order-sidebar')
        const header = document.querySelector('header')
        const headerSizePixels = 44

        if (sidebar.scrollHeight >= window.innerHeight - header.scrollHeight) {
          this.setState(
            {
              top:
                window.innerHeight -
                (header.scrollHeight + sidebar.scrollHeight) +
                headerSizePixels,
            },
            () => this.throttleHandleScroll(),
          )
        } else {
          this.setState({ top: 16 }, () => this.throttleHandleScroll())
        }
      })
    }
  }

  render() {
    const {
      cancelEditingOrder,
      deliveryDropoff,
      favorites,
      hashes,
      isAuthenticated,
      isDeliveryDropoffLoading,
      isEditingOrder,
      isEditingPastOrder,
      isLocationLoading,
      isOrderCartLoading,
      loadEditOrder,
      location,
      menuItemForEdit,
      normalizedMenuItem,
      orderCart,
      orderCartError,
      push,
      removeItemFromOrderCartStart,
    } = this.props
    const disabledCheckout = !isAuthenticated
    return (
      <div className="sticky order-sidebar" style={{ top: this.state.top }}>
        <SpinnerCard
          key="location"
          spinnerActive={
            isLocationLoading || isDeliveryDropoffLoading || isOrderCartLoading
          }
        >
          <SidebarDeliveryLocation
            deliveryDropoff={deliveryDropoff}
            loading={isDeliveryDropoffLoading}
            style={{ paddingBottom: '10px' }}
          />
          {!isLocationLoading && location && (
            <Location>
              <LocationContainer>
                <LocationBuilding
                  address={location.address}
                  name={location.deliveryLocationName}
                  showLink={false}
                />
              </LocationContainer>
            </Location>
          )}
          <hr />
          {orderCart && deliveryDropoff && (
            <OrderCart
              cart={orderCart}
              deleteMenuItem={removeItemFromOrderCartStart}
              dropoffId={deliveryDropoff.dropoffId}
              editable="true"
              editMenuItem={loadEditOrder}
              error={orderCartError}
              isEditingPastOrder={false}
              isInvalid={disabledCheckout}
              onCheckout={() =>
                push(
                  formatUrl(checkoutRoute.path, {
                    locationId: location.deliveryLocationId,
                    dropoffId: deliveryDropoff.dropoffId,
                  }),
                )
              }
              showEditLinks="true"
            />
          )}
        </SpinnerCard>
        {!isEditingPastOrder && menuItemForEdit && isEditingOrder ? (
          <ModalPopup
            id="personalize-modal"
            onCancel={() => {
              cancelEditingOrder()
            }}
          >
            <PersonalizeOrder
              dropoffId={deliveryDropoff.dropoffId}
              favorites={
                favorites &&
                favorites.filter(
                  favorite =>
                    favorite.menuItemId === menuItemForEdit.menuItemId,
                )
              }
              hashes={
                hashes &&
                hashes.filter(
                  hash => hash.menuItemId === menuItemForEdit.menuItemId,
                )
              }
              isEditingFromCheckout={false}
              isEditingFromMenu="true"
              isEditingOrder={isEditingOrder}
              isEditingPastOrder={false}
              locationId={location.deliveryLocationId}
              menuItemForEdit={menuItemForEdit}
              menuItemId={menuItemForEdit.menuItemId}
              normalizedMenuItem={normalizedMenuItem}
            />
          </ModalPopup>
        ) : null}
        <SubscriptionPromoButtonRotatingTitle />
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { orderCart, orderCartError, isOrderCartLoading } = state.cart
  const { isAuthenticated } = state.user
  const { favorites, hashes } = state.favorite
  const { normalizedMenuItem } = state.personalize
  const { deliveryDropoff, isDeliveryDropoffLoading } = state.delivery
  const location = selectCurrentLocationWithAddress(state)
  const menuItemForEdit = selectMenuItemForEdit(state)
  const { isLocationLoading } = state.location
  const { isEditingOrder, isEditingPastOrder } = state.cart
  return {
    deliveryDropoff,
    orderCart,
    orderCartError,
    isOrderCartLoading,
    isDeliveryDropoffLoading,
    isAuthenticated,
    location,
    isLocationLoading,
    normalizedMenuItem,
    isEditingOrder,
    favorites,
    hashes,
    menuItemForEdit,
    isEditingPastOrder,
  }
}

const mapDispatchToProps = {
  removeItemFromOrderCartStart,
  currentUserStart,
  loadEditOrder,
  cancelEditingOrder,
  push,
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderSidebar)
